<template>
  <b-button
    :inline-block="!isFlex"
    :disabled="disabled"
    :class="{
      'common-btn': !isFlex,
      'flex-btn': isFlex,
      'default-color': isSecondary,
      radius: rounded,
      sm: size === 'sm',
    }"
    :size="size"
    :variant="variant"
    v-on:click="onClick"
    >{{ label }}</b-button
  >
</template>

<style scoped lang="scss">
.common-btn {
  width: 167px;
  height: 42px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}

.flex-btn {
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
}

.default-color {
  background-color: #8ca6b7;
  border-color: #8ca6b7;

  &.btn-secondary.disabled {
    background-color: #e2e2e2;
    border-color: #e2e2e2;
    color: #b3b3b3;
    opacity: 1;
  }
}

.btn-info.disabled {
  background-color: gray;
  border-color: gray;
  cursor: not-allowed;
}

.btn-danger.disabled {
  background-color: #e3d0d9;
  border-color: #e3d0d9;
  cursor: not-allowed;
}
</style>

<script lang="ts">
import { computed, defineComponent } from "vue";
export default defineComponent({
  name: "custom-button",
  props: {
    label: { type: String, default: "確認", required: true },
    disabled: { type: Boolean, default: false },
    variant: { type: String, default: "info" },
    // "sm" or "lg"
    size: { type: String, default: "sm" },
    // false  diplay: inline-block;
    // true   display: flex;
    isFlex: { type: Boolean, default: false },
    // border-radius: 10px; のクラス radius付与
    rounded: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const isSecondary = computed((): boolean => props.variant === "secondary");

    const onClick = (): void => {
      emit("confirm");
    };

    return { isSecondary, onClick };
  },
});
</script>
